import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/SENGI-logo1.png';
import _imports_1 from '@/assets/pt-logo.png';

const _withScopeId = n => (_pushScopeId("data-v-bafb1310"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "container"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  name: "",
  id: "check"
}, null, -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sengi-logo-container"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "sengi-logo"
})], -1));

const _hoisted_4 = {
  class: "nav-btn"
};
const _hoisted_5 = {
  class: "nav-links"
};
const _hoisted_6 = {
  href: "#"
};
const _hoisted_7 = {
  href: "#"
};
const _hoisted_8 = {
  href: "#"
};
const _hoisted_9 = {
  href: "#"
};
const _hoisted_10 = {
  class: "dropdown"
};
const _hoisted_11 = {
  href: "#"
};
const _hoisted_12 = {
  href: "#"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "arrow"
}, null, -1));

const _hoisted_14 = {
  href: "#"
};
const _hoisted_15 = {
  class: "log-sign",
  style: {
    "--i": "1.8s"
  }
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pt-logo-container"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "pt-logo"
})], -1));

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hamburger-menu-container"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "hamburger-menu"
}, [/*#__PURE__*/_createElementVNode("div")])], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  const _component_My_language = _resolveComponent("My-language");

  return _openBlock(), _createElementBlock("header", null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("ul", null, [_createElementVNode("li", {
    class: _normalizeClass(["nav-link", _ctx.type === 'en' ? 'nav-link-mobile' : '']),
    id: "aaa",
    style: {
      "--i": "0.6s"
    },
    onClick: _cache[0] || (_cache[0] = $event => _ctx.resetActive())
  }, [_createVNode(_component_router_link, {
    to: '/home'
  }, {
    default: _withCtx(() => [_createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.translateTitle("主页")), 1)]),
    _: 1
  })], 2), _createElementVNode("li", {
    class: _normalizeClass(["nav-link", _ctx.type === 'en' ? 'nav-link-mobile' : '']),
    id: "bbb",
    style: {
      "--i": "0.6s"
    },
    onClick: _cache[1] || (_cache[1] = $event => _ctx.resetActive())
  }, [_createVNode(_component_router_link, {
    to: '/about'
  }, {
    default: _withCtx(() => [_createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.translateTitle("关于我们")), 1)]),
    _: 1
  })], 2), _createElementVNode("li", {
    class: _normalizeClass(["nav-link", _ctx.type === 'en' ? 'nav-link-mobile' : '']),
    style: {
      "--i": "0.6s"
    },
    onClick: _cache[2] || (_cache[2] = $event => _ctx.resetActive())
  }, [_createVNode(_component_router_link, {
    to: '/product'
  }, {
    default: _withCtx(() => [_createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.translateTitle("产品")), 1)]),
    _: 1
  })], 2), _createElementVNode("li", {
    class: _normalizeClass(["nav-link", _ctx.type === 'en' ? 'nav-link-mobile' : '']),
    style: {
      "--i": "0.6s"
    }
  }, [_createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.translateTitle("企业")), 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("ul", null, [_createElementVNode("li", {
    class: "dropdown-link",
    onClick: _cache[3] || (_cache[3] = $event => _ctx.resetActive())
  }, [_createVNode(_component_router_link, {
    to: '/news'
  }, {
    default: _withCtx(() => [_createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.translateTitle("相关资讯")), 1)]),
    _: 1
  })]), _createElementVNode("li", {
    class: "dropdown-link",
    onClick: _cache[4] || (_cache[4] = $event => _ctx.resetActive())
  }, [_createVNode(_component_router_link, {
    to: '/video'
  }, {
    default: _withCtx(() => [_createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.translateTitle("视频介绍")), 1)]),
    _: 1
  })]), _hoisted_13])])], 2), _createElementVNode("li", {
    class: _normalizeClass(["nav-link", _ctx.type === 'en' ? 'nav-link-mobile' : '']),
    style: {
      "--i": "0.6s"
    },
    onClick: _cache[5] || (_cache[5] = $event => _ctx.resetActive())
  }, [_createVNode(_component_router_link, {
    to: '/contact'
  }, {
    default: _withCtx(() => [_createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.translateTitle("联系我们")), 1)]),
    _: 1
  })], 2)])]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_My_language)])]), _hoisted_16, _hoisted_17])]);
}